import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthServiceInterface, AuthServiceProvider } from 'common';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IsNotLoggedGuard implements CanActivate {

  constructor(private authProvider: AuthServiceProvider,
              private router: Router) {
  }

  canActivate(_: ActivatedRouteSnapshot, _2: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authProvider.getService()
      .pipe(
        mergeMap(service => service.isLogged()),
        map(logged => {
          if (logged) {
            this.router.navigate(['/app']);
          }
          return !logged;
        }),
        catchError(() => {
          return of(true);
        }),
      );
  }

}
